<template>
  <div>
    <p class="text-xl font-bold mb-4">{{ t("title") }}</p>
    <div class="overflow-x-auto shadow-lg bg-gray-50 rounded-lg">
      <table class="table-auto w-full text-left border-collapse text-sm">
        <thead class="bg-gray-100">
          <tr>
            <th class="px-4 py-3 text-gray-600 font-semibold w-12"></th>
            <th class="px-4 py-3 text-gray-600 font-semibold">{{ t("seller_name") }}</th>
            <th class="px-4 py-3 text-gray-600 font-semibold text-right">
              {{ t(`challenge.counting.${countingMethod}.column`) }}
            </th>
            <th class="px-4 py-3 text-gray-600 font-semibold text-right">{{ t("reward") }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="seller in displayedSellers" :key="seller.id">
            <td class="px-4 py-2">
              <span v-if="seller.rank <= 3">{{ medalIcons[seller.rank - 1] }}</span>
              <span v-else>{{ seller.rank }}</span>
            </td>
            <td class="px-4 py-2 font-medium">{{ seller.name }}</td>
            <td class="px-4 py-2 text-right">{{ seller.score }}</td>
            <td class="px-4 py-2 text-right font-semibold">{{ sellerReward(salesTargets, seller) }}</td>
          </tr>
        </tbody>
      </table>
      <button
        v-if="hasMore"
        class="w-full py-2 text-sm text-primary-dark font-medium hover:bg-gray-100 transition-colors"
        @click="expanded = !expanded"
      >
        {{ expanded ? t("show_less") : t("show_more") }}
      </button>
    </div>
  </div>
</template>

<script>
import { useI18n } from "vue-i18n";
import { computeCompetitionRanking } from "@estaly/ui";
import { sellerReward } from "@/utils/challengeTiers";

const MEDAL_ICONS = ["\uD83E\uDD47", "\uD83E\uDD48", "\uD83E\uDD49"];
const INITIAL_COUNT = 5;

export default {
  setup() {
    const { t } = useI18n();
    return { t };
  },

  props: {
    sellers: {
      type: Array,
      required: true,
    },
    salesTargets: {
      type: Array,
      default: () => [],
    },
    countingMethod: {
      type: String,
      default: "plan_sales",
    },
  },

  data() {
    return {
      medalIcons: MEDAL_ICONS,
      expanded: false,
    };
  },

  computed: {
    rankedSellers() {
      const sorted = [...this.sellers].sort((a, b) => (b.score || 0) - (a.score || 0));
      return computeCompetitionRanking(sorted, "score");
    },

    displayedSellers() {
      return this.expanded ? this.rankedSellers : this.rankedSellers.slice(0, INITIAL_COUNT);
    },

    hasMore() {
      return this.rankedSellers.length > INITIAL_COUNT;
    },
  },

  methods: {
    sellerReward,
  },
};
</script>

<i18n src="./TieredChallengeSellerRanking.i18n.json"></i18n>
